import React from "react";

const PageNotFound = () => {
	return(
		<div>
			PageNotFound
		</div>
	);
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./routes/PageNotFound.js